<template>
  <div id="workflowsProcess">
    <card :title="$t('w-process:filter')" :visible="filterVisibility" collapsible>
      <div slot="card-body">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="status" class="control-label">{{ $t('w-process:status') | capitalize }}</label>
            <select id="status"
                    v-model="filterStatus"
                    class="form-control"
                    name="status"
            >
              <option value="" />
              <option value="PENDING">{{ $t('w-process:PENDING') | capitalize }}</option>
              <option value="OK">{{ $t('w-process:OK') }}</option>
              <option value="KO">{{ $t('w-process:KO') }}</option>
            </select>
          </div>
        </div>
      </div>

      <div slot="card-footer">
        <button id="filterButton" class="btn btn-primary" @click="filter()">{{ $t('w-process:search') | capitalize }}</button>
      </div>
    </card>

    <grid id="workflowProcessGrid"
          :title="workflowName"
          :columns="columns"
          :paginated-dto="processes"
          @load="filter"
    >
      <template slot="equipment" slot-scope="props">
        <router-link :to="'/workflows/result/' + props.dto.id">{{ getEquipmentId(props.dto) }}</router-link>
      </template>
      <template slot="status" slot-scope="props">
        <span :class="getStatusColor(props.dto.status)">{{ props.dto.status }}</span>
      </template>
      <template slot="startTime" slot-scope="props">{{ props.dto.startTime | date }}</template>
      <template slot="endTime" slot-scope="props">{{ props.dto.endTime | date }}</template>
    </grid>
  </div>
</template>

<script>
import to from '@/modules/await-to-js'

export default {
  titleKey: 'workflowsProcess',

  props: {
    // id of the processes
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      workflowName: '',
      // Filter
      filterVisibility: false,
      filterStatus: '',
      // Grid
      processes: {}
    }
  },

  computed: {
    columns () {
      const columns = [
        { text: this.$t('w-process:id'), formatter: process => process.id },
        { text: this.$t('w-process:equipment'), slot: 'equipment' },
        { text: this.$t('w-process:status'), slot: 'status' },
        { text: this.$t('w-process:startTime'), slot: 'startTime' },
        { text: this.$t('w-process:endTime'), slot: 'endTime' }
      ]

      return columns
    }
  },

  watch: {
    id () {
      // Need to reset as this component is used in two pages
      this.filterVisibility = false
      this.filterStatus = null
      this.processes = {}
      // And filter
      this.filter()
    }
  },

  created () {
    this.filter()
  },

  methods: {
    async filter (options = {}) {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      // Add filters
      if (this.filterStatus) options.status = this.filterStatus

      // Get filtered data
      this.getProcess(options)
    },

    async getProcess (options) {
      let error, response
      [error, response] = await to(this.$api.getWorkflowProcessInstances(
        this.$store.getters.application,
        this.id,
        this.$utils.getParams({ status: '' }, options, this.queryPageParams)
      ))
      if (error || !response) return

      this.processes = response.data
      this.workflowName = response.data.count > 0 ? response.data.list[0].processDefinitionName : ''
    },

    // KO: red, PENDING: orange, OK: green
    getStatusColor (status) {
      return status === 'KO' ? 'text-danger' : (status === 'OK' ? 'text-success' : 'text-warning')
    },

    // Get equipment id (eui / devEui) from processVariables
    getEquipmentId (dto) {
      if (dto.processVariables) return dto.processVariables.euis || dto.processVariables.devEui || ''
    }
  }
}
</script>
